import { useEffect, useRef } from 'react';
import { useRouter } from 'shared-routing';

import { redirectToListing } from '@common/helpers/notFoundRedirect';

// A client navigation reaches a detail page with no response to redirect with,
// so the component decides once its query settles.
export const useRedirectWhenMissing = (isMissing: boolean, listing: string) => {
  const router = useRouter();
  const hasRedirected = useRef(false);

  useEffect(() => {
    if (!isMissing || hasRedirected.current) return;

    hasRedirected.current = true;
    // Read here rather than tracked: makePublicRouterInstance clones query for
    // every render, so a dependency on it would re-fire and cancel its own
    // navigation.
    redirectToListing(undefined, listing, router.query);
  }, [isMissing, listing]);
};
